import { createFileRoute } from "@tanstack/react-router";
import AdminDiagnosticadorLocales from "@/pages/admin/AdminDiagnosticadorLocales";

function ZonesPage() {
  return <AdminDiagnosticadorLocales mode="zones" />;
}

// ?tab=leads se redirige a /admin/leads?origen=diagnosticador desde src/routes/admin.tsx.
export const Route = createFileRoute("/admin/diagnosticador-locales")({
  validateSearch: (search: Record<string, unknown>): { tab?: string | undefined } => ({
    tab: typeof search["tab"] === "string" ? (search["tab"] as string) : undefined,
  }),
  component: ZonesPage,
});
